module.exports = __webpack_public_path__ + "img/Tomato.a2f9bde0.svg";